import { render, staticRenderFns } from "./RatingsTopMenu.vue?vue&type=template&id=1189cfdc"
import script from "./RatingsTopMenu.vue?vue&type=script&lang=js"
export * from "./RatingsTopMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports